import { useCallback } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { type SelectChangeEvent } from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import type { AdmissionRecheckScope } from "../../../lib/corpusApi";
import { DOCUMENT_SCOPE_OPTIONS } from "./document_scopes";
import type { DocumentScopeState } from "./useDocumentScope";

export interface DocumentScopeFieldProps {
  form: DocumentScopeState;
}

/** The scope picker of a job over existing documents, with how many documents the choice covers. */
export function DocumentScopeField({ form }: DocumentScopeFieldProps) {
  const { scope, setScope, scopeCount } = form;

  const handleScopeChange = useCallback(
    (e: SelectChangeEvent) => setScope(e.target.value as AdmissionRecheckScope),
    [setScope]
  );

  return (
    <>
      <FormControl fullWidth size="small">
        <InputLabel id="batch-job-scope-label">Scope</InputLabel>
        <Select
          labelId="batch-job-scope-label"
          label="Scope"
          value={scope}
          onChange={handleScopeChange}
        >
          {DOCUMENT_SCOPE_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography variant="body2" color="text.secondary">
        {scopeCount !== null ? `${scopeCount} document(s) in scope.` : "Loading scope size…"}
      </Typography>
    </>
  );
}
